import { Link } from "react-router";
import styled from "styled-components";
import BlinkingCursor from "../components/BlinkingCursor";

const MobileWelcomePage = () => {
  return (
    <MobileWrapper>
      <Title>stakra</Title>
      <MainHeading>
        stakra is a scriptable video player on the web with a command-line
        interface
      </MainHeading>
      <AboutContent>
        <p>
          stakra was conceived as a design study of what a HTML5 video player
          with a pure CLI could look like, and how one might interact with it.
        </p>
        <p>
          This is an ongoing design project by{" "}
          <Link to={"https://www.acrosspolyethylene.com/"}>
            Sumanth Srinivasan
          </Link>
        </p>
        <EmphasizedParagraph>
          Please visit this URL on a desktop to access stakra.
        </EmphasizedParagraph>
      </AboutContent>
      <BlinkingCursor />
    </MobileWrapper>
  );
};

export default MobileWelcomePage;

const Title = styled.div`
  font-family: Faustina;
  font-size: 24px;
  line-height: 32px;
  height: 48px;
  font-weight: 500;
`;

const MainHeading = styled.div`
  width: 100%;
  font-weight: bold;
`;

const AboutContent = styled.div`
  width: 100%;

  > p > a {
    color: unset;
    text-decoration: underline;
  }
`;

const MobileWrapper = styled.div`
  background: rgb(21, 21, 21);
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: rgb(180, 210, 115);
  padding: 10%;
  box-sizing: border-box;
`;

const EmphasizedParagraph = styled.p`
  font-weight: bold;
`;
